export default __webpack_public_path__ + "static/media/btc.7a4072aa.png";